import { Calculator, Gauge, Scale, BookOpen, Lightbulb, Layers, Brain, Landmark, type LucideIcon } from "lucide-react";

/** Kategorie-Icons für die Akademie (2026-07-23, Erik: "mehr Bilder, Logos und
 * Grafiken, ohne dass es verwirrender wirkt") - gemeinsame Zuordnung für Übersicht
 * (academy-search.tsx) und Artikelseite, damit dieselbe Kategorie überall dasselbe
 * Icon zeigt statt zweier unabhängig gepflegter Zuordnungen. Icon-Wahl übernimmt die
 * bereits in academy-search.tsx etablierte Zuordnung unverändert.
 * 2026-08-19-Großausbau: 4 neue Kategorien ergänzt. */
const CATEGORY_ICONS: Record<string, LucideIcon> = {
  Grundlagen: Lightbulb,
  "Kennzahlen verstehen": Calculator,
  "ETFs verstehen": Layers,
  "Der Erikonomie-Score": Gauge,
  Bewertung: Scale,
  "Depot & Strategie": BookOpen,
  "Strategie & Psychologie": Brain,
  "Steuern für Anleger": Landmark,
};

export function CategoryIcon({ category, className }: { category: string; className?: string }) {
  const Icon = CATEGORY_ICONS[category] ?? BookOpen;
  return <Icon className={className} aria-hidden="true" />;
}
